export const contactContent = {
  headline: "Get In Touch",
  subheadline: "Whether you're ready to begin your wellness journey or simply have questions, we're here. Reach out and we'll respond thoughtfully.",
  
  contactInfo: [
    {
      icon: "ri-map-pin-line",
      title: "Location",
      details: [
        "63 High Street",
        "Wanstead, London",
        "E11 2AE"
      ]
    },
    {
      icon: "ri-phone-line",
      title: "Contact",
      details: [
        "020 XXXX XXXX",
        "hello@resetnow.co.uk"
      ]
    },
    {
      icon: "ri-time-line",
      title: "Hours",
      details: [
        "Monday – Friday: 7am – 9pm",
        "Saturday – Sunday: 8am – 8pm"
      ]
    }
  ],

  formTypes: [
    {
      id: "general",
      label: "General Enquiry"
    },
    {
      id: "pilates",
      label: "Pilates Booking"
    },
    {
      id: "thermal",
      label: "Thermal Suite"
    },
    {
      id: "cafe",
      label: "Café Reservation"
    }
  ],

  visitInfo: {
    description: "Located in the heart of Wanstead village. Easy access from Central Line stations and local bus routes.",
    address: "RE:SET Wellness Sanctuary",
    street: "63 High Street, Wanstead",
    city: "London, E11 2AE",
    transport: [
      {
        icon: "ri-train-line",
        details: [
          "5 minutes from Wanstead Station (Central Line)",
          "5 minutes from Snaresbrook Station (Central Line)"
        ]
      },
      {
        icon: "ri-bus-line",
        details: [
          "Bus routes: 101, 308, W13, W14",
          "Stops: Wanstead High Street, Cambridge Park"
        ]
      },
      {
        icon: "ri-car-line",
        details: [
          "Street parking available nearby"
        ]
      }
    ],
    mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2479.123456789!2d0.0275!3d51.5775!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNTHCsDM0JzM5LjAiTiAwwrAwMSczkjkuMCJF!5e0!3m2!1sen!2suk!4v1234567890"
  }
};
